<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_363_827)">
      <path d="M8 14.6666C11.6819 14.6666 14.6667 11.6819 14.6667 7.99998C14.6667 4.31808 11.6819 1.33331 8 1.33331C4.3181 1.33331 1.33334 4.31808 1.33334 7.99998C1.33334 11.6819 4.3181 14.6666 8 14.6666Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M9.88667 9.88665C9.51361 10.2593 9.03845 10.513 8.52125 10.6156C8.00405 10.7183 7.46802 10.6653 6.98093 10.4634C6.49383 10.2615 6.07753 9.91966 5.78464 9.48119C5.49176 9.04273 5.33543 8.52727 5.33543 7.99998C5.33543 7.47269 5.49176 6.95724 5.78464 6.51877C6.07753 6.0803 6.49383 5.73851 6.98093 5.53659C7.46802 5.33467 8.00405 5.28168 8.52125 5.38434C9.03845 5.48699 9.51361 5.74067 9.88667 6.11331" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
      <clipPath id="clip0_363_827">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<script>
export default {
  name: 'copy-right'
}
</script>



// WEBPACK FOOTER //
// src/ui/icon/CopyRight.vue